import Title from "../components/Title";

const experiences = [
  {
    title: "Senior Software Engineer",
    time: "Jan 2021 — Current",
    company: "Redcat Cloud Solutions",
    description:
      "Building web, mobile, kiosk and desktop applications for the hospitality industry, and migrating legacy systems to modern stacks (Python, React Native).",
  },
  {
    title: "Full Stack Software Engineer",
    time: "April 2019 — Jan 2021",
    company: "Frozberries Vic",
    description: "Expanding online existence",
  },
  {
    title: "Freelance Software Engineer",
    time: "Since 2018",
    description: "Full stack ecommerce sites — written on the MERN stack",
  },
];

const skills = [
  "React",
  "React Native",
  "TypeScript",
  "Next.js",
  "Node.js",
  "Electron",
  "Python",
  "FastAPI",
  "MySQL",
  "NoSQL",
  "WebSockets",
];

const learning = ["AI agents", "Go"];

const Experience = () => {
  return (
    <div>
      <section className="section">
        <Title title="Job experience" />
        {experiences.map((experience) => (
          <div className="entry" key={experience.title}>
            <h3 className="entry-title">{experience.title}</h3>
            <p className="entry-meta">
              {experience.company && (
                <>
                  <span className="entry-company">{experience.company}</span>
                  {" · "}
                </>
              )}
              {experience.time}
            </p>
            <p className="entry-desc">{experience.description}</p>
          </div>
        ))}
      </section>

      <div className="skills-grid">
        <section className="section">
          <Title title="Skills" />
          <ul className="skill-list">
            {skills.map((skill) => (
              <li key={skill}>{skill}</li>
            ))}
          </ul>
        </section>

        <section className="section">
          <Title title="Current interests" />
          <ul className="skill-list">
            {learning.map((skill) => (
              <li key={skill}>{skill}</li>
            ))}
          </ul>
        </section>
      </div>
    </div>
  );
};

export default Experience;
